if (!String.prototype.format) {
  // eslint-disable-next-line func-names
  String.prototype.format = function () {
    // eslint-disable-next-line prefer-rest-params
    const args = arguments
    return this.replace(/{(\d+)}/g, (match, number) => {
      return typeof args[number] !== 'undefined' ? args[number] : match
    })
  }
}